import ReviewField, {
  isFatherFieldGroup,
  isNameFieldGroup,
} from "../ReviewField";
import SectionDocuments from "../SectionDocuments";
import "./PersonalSection.css";

const PersonalSection = ({
  fields = [],
  formData,
  fieldFlags,
  flagModeEnabled,
  restrictToUpdatedFields,
  updatedFields,
  flagModal,
  focusedFlagKey,
  onOpenFlagModal,
  onUpdateField,
  documents = [],
  getFileIcon,
  onPreviewDoc,
}) => {
  const fieldProps = {
    sectionKey: "personal",
    formData,
    fieldFlags,
    flagModeEnabled,
    restrictToUpdatedFields,
    updatedFields,
    flagModal,
    focusedFlagKey,
    onOpenFlagModal,
    onUpdateField,
  };

  const nodes = [];
  for (let index = 0; index < fields.length; index += 1) {
    if (isNameFieldGroup(fields, index)) {
      const nameFields = fields.slice(index, index + 3);
      nodes.push(
        <div className="rr-name-row" key={`personal-name-row-${index}`}>
          {nameFields.map((field) => (
            <ReviewField
              key={field.key}
              {...fieldProps}
              field={field}
              options={{ isNameField: true }}
            />
          ))}
        </div>,
      );
      index += 2;
      continue;
    }

    if (isFatherFieldGroup(fields, index)) {
      const fatherFields = fields.slice(index, index + 3);
      nodes.push(
        <div className="rr-name-row" key={`personal-father-row-${index}`}>
          {fatherFields.map((field) => (
            <ReviewField
              key={field.key}
              {...fieldProps}
              field={field}
              options={{ isNameField: true }}
            />
          ))}
        </div>,
      );
      index += 2;
      continue;
    }

    const field = fields[index];
    if (field?.type === "heading") {
      nodes.push(
        <div
          key={`personal-heading-break-${field.label}`}
          className="rr-flex-break"
          aria-hidden="true"
        />,
      );
      nodes.push(
        <div
          key={`personal-heading-${field.label}`}
          className={`rr-subsection-head${
            index === 0 ? " rr-subsection-head--first" : ""
          }`}
        >
          <div className="form-subhead">{field.label}</div>
        </div>,
      );
      continue;
    }

    nodes.push(
      <ReviewField key={field.key} {...fieldProps} field={field} />,
    );
  }

  return (
    <>
      <div className="flex flex-wrap">{nodes}</div>
      <SectionDocuments
        sectionKey="personal"
        documents={documents}
        getFileIcon={getFileIcon}
        onPreviewDoc={onPreviewDoc}
        fieldFlags={fieldFlags}
        flagModeEnabled={flagModeEnabled}
        restrictToUpdatedFields={restrictToUpdatedFields}
        updatedFields={updatedFields}
        flagModal={flagModal}
        focusedFlagKey={focusedFlagKey}
        onOpenFlagModal={onOpenFlagModal}
      />
    </>
  );
};

export default PersonalSection;
